const newArrayLength = (length) => {
  const array = [];
  for (let i = 0; i < length; i += 1) {
    array.push(i);
  }
  return array;
};
const interleave = (arr, thing) => [].concat(...arr.map((n) => [n, thing])).slice(0, -1);

export { interleave, newArrayLength };
//# sourceMappingURL=index.js.map
